import React from 'react';
import './landing.css';

export default function Landing(){
  return (
    <main>
      {/* Landing content; global NavBar handles navigation to avoid duplication. */}
      <header id="home" className="bg-hero">
        <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
          </div>

          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="carousel-img" style={{backgroundImage: `url('/images/auditorium1.jpg')`}}></div>
              <div className="carousel-caption text-start text-white">
                <h1 className="display-5 fw-bold">Manage Events With Confidence</h1>
                <p className="lead">Automate hall bookings, approvals and resource allocation with a single dashboard.</p>
                <p>
                  <a className="btn btn-success btn-lg me-2" href="#">Book Now</a>
                  <a className="btn btn-outline-light btn-lg" href="#features">Explore Features</a>
                </p>
              </div>
            </div>

            <div className="carousel-item">
              <div className="carousel-img" style={{backgroundImage: `url('/images/auditorium2.jpg')`}}></div>
              <div className="carousel-caption text-start text-white">
                <h1 className="display-5 fw-bold">Smooth Scheduling & Capacity Control</h1>
                <p className="lead">Avoid double bookings and set capacity rules for every event and hall.</p>
                <p>
                  <a className="btn btn-success btn-lg me-2" href="#">Book Now</a>
                  <a className="btn btn-outline-light btn-lg" href="#about">Learn More</a>
                </p>
              </div>
            </div>

            <div className="carousel-item">
              <div className="carousel-img" style={{backgroundImage: `url('/images/auditorium3.jpg')`}}></div>
              <div className="carousel-caption text-start text-white">
                <h1 className="display-5 fw-bold">Track Maintenance & Security</h1>
                <p className="lead">Assign maintenance tasks and security teams for each booking to keep operations reliable.</p>
                <p>
                  <a className="btn btn-success btn-lg me-2" href="#">Get Started</a>
                  <a className="btn btn-outline-light btn-lg" href="#contact">Contact Sales</a>
                </p>
              </div>
            </div>
          </div>

          <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev" aria-label="Previous">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next" aria-label="Next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>
      </header>

      <section id="about" className="py-6 bg-light">
        <div className="container">
          <div className="about-grid">
            <div className="about-media">
              <img src="/images/auditorium2.jpg" alt="Auditorium hall" className="img-fluid rounded shadow-sm" />
            </div>
            <div className="about-copy">
              <h2 className="fw-bold">Welcome to the Auditorium Management System</h2>
              <p className="lead text-muted">Automate hall booking, approvals, scheduling and maintenance from one central dashboard. Save time and reduce conflicts with structured workflows and clear reporting.</p>
              <ul className="features-list">
                <li>Centralized bookings & calendars</li>
                <li>Role-based approvals and secure access</li>
                <li>Maintenance workflows and audit-ready reports</li>
              </ul>
              <div className="mt-3">
                <a href="#features" className="btn btn-outline-primary btn-lg me-2">See Features</a>
                <a href="/login" className="btn btn-primary btn-lg">Get Started</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="py-6">
        <div className="container">
          <div className="text-center mb-5">
            <h3 className="fw-bold">Key Features</h3>
            <p className="text-muted">Everything you need to manage events, bookings, maintenance and security.</p>
          </div>

          <div className="features-grid">
            <article className="feature-card card">
              <div className="card-body text-center">
                <div className="feature-icon bg-indigo-50 text-indigo-600 mb-3"><i className="bi bi-calendar2-event fs-2" aria-hidden="true"></i></div>
                <h5 className="card-title">Hall Booking</h5>
                <p className="card-text text-muted">Instant availability checks, booking conflicts avoided and capacity management.</p>
              </div>
            </article>

            <article className="feature-card card">
              <div className="card-body text-center">
                <div className="feature-icon bg-emerald-50 text-emerald-600 mb-3"><i className="bi bi-people-fill fs-2" aria-hidden="true"></i></div>
                <h5 className="card-title">Event Management</h5>
                <p className="card-text text-muted">Manage speakers, schedules and resources for each event with ease.</p>
              </div>
            </article>

            <article className="feature-card card">
              <div className="card-body text-center">
                <div className="feature-icon bg-yellow-50 text-yellow-600 mb-3"><i className="bi bi-shield-lock-fill fs-2" aria-hidden="true"></i></div>
                <h5 className="card-title">Security Assignment</h5>
                <p className="card-text text-muted">Assign security teams and track duties per event or hall.</p>
              </div>
            </article>

            <article className="feature-card card">
              <div className="card-body text-center">
                <div className="feature-icon bg-red-50 text-red-600 mb-3"><i className="bi bi-tools fs-2" aria-hidden="true"></i></div>
                <h5 className="card-title">Maintenance Requests</h5>
                <p className="card-text text-muted">Log, assign and monitor maintenance tasks before or after events.</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section id="contact" className="py-6 bg-light">
        <div className="container text-center">
          <h4 className="fw-bold">Ready to streamline your venue operations?</h4>
          <p className="text-muted mb-4">Start a free trial or contact our sales team to schedule a demo.</p>
          <a className="btn btn-primary btn-lg me-2" href="/signup">Start Free Trial</a>
          <a className="btn btn-outline-secondary btn-lg" href="mailto:sales@auditorium.local">Contact Sales</a>
        </div>
      </section>

      {/* Footer is provided globally by the site's `Footer` component; avoid duplicating it here. */}
    </main>
  );
}